import './AnnouncementModal.css'
import {useTranslation} from 'react-i18next';
import { useState, useRef } from 'react';
import { createAnnouncement } from '../../api/communication';
import LoadingIndicator from '../Common/LoadingIndicator';

function AnnouncementModal({ closeModal }) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    // setIsSubmitting(true) only takes effect on the next render, so a fast double-click can fire
    // this handler twice before the button actually disables -- both calls would then see the
    // still-stale isSubmitting === false and both POST. A ref updates synchronously, so it blocks
    // the second call immediately regardless of render timing.
    const isSubmittingRef = useRef(false);
    const { t } = useTranslation();


    const formatText = (command, value = null) => {
      document.execCommand(command, false, value);
      document.getElementById('announcementMessage').focus();
    };
    const confirmSendAnnouncement = async () => {
        if (isSubmittingRef.current) return;
        const subject = document.getElementById('announcementSubject').value.trim();
        // The toolbar's bold/color/highlight buttons operate via document.execCommand on this
        // contenteditable div, which already produces HTML -- capturing innerHTML directly
        // (matching how Exam.jsx's question-text editor persists its own contenteditable
        // formatting) avoids inventing a parallel markup syntax for the same thing.
        const message = document.getElementById('announcementMessage').innerHTML.trim();
        const isImportant = document.getElementById('announcementImportant').checked;

        if (!subject) return alert(t('announcementModal.subjectRequired'));
        if (!message) return alert(t('announcementModal.messageRequired'));

        isSubmittingRef.current = true;
        setIsSubmitting(true);
        try {
            const newAnnouncement = await createAnnouncement({
                subject,
                message,
                is_important: isImportant,
            });
            console.log('Announcement sent:', newAnnouncement);
            closeModal(true);
        } catch (error) {
            console.error('Error sending announcement:', error);
            alert(t('announcementModal.sendFailed'));
        } finally {
            isSubmittingRef.current = false;
            setIsSubmitting(false);
        }
    };

    return (
    <>
        <LoadingIndicator active={isSubmitting} label={t('common.loading')} />
        <div id="modalSendAnnouncement" className="modal-overlay">
        <div className="modal-box" style={{ width: '600px' }}>
        <h2>{t('announcementModal.title')}</h2>

        <label className="label-text-announcement">{t('announcementModal.subjectLabel')}</label>
        <input type="text" id="announcementSubject" className="login-input-announcement" placeholder={t('announcementModal.subjectPlaceholder')} />

        <label className="label-text-announcement">{t('announcementModal.messageLabel')}</label>
        <div className="editor-toolbar-announcement">
            <button type="button" onClick={() => formatText('bold')} title={t('announcementModal.bold')}><b>B</b></button>
            <button type="button" onClick={() => formatText('italic')} title={t('announcementModal.italic')}><i>I</i></button>

            <div className="toolbar-divider"></div>

            <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: '4px' }}>{t('announcementModal.colorLabel')}</span>
            <button type="button" className="color-btn text-color-btn" style={{ color: '#ef4444' }} onClick={() => formatText('foreColor', '#ef4444')} title={t('announcementModal.redText')}>A</button>
            <button type="button" className="color-btn text-color-btn" style={{ color: '#3b82f6' }} onClick={() => formatText('foreColor', '#3b82f6')} title={t('announcementModal.blueText')}>A</button>
            <button type="button" className="color-btn text-color-btn" style={{ color: '#10b981' }} onClick={() => formatText('foreColor', '#10b981')} title={t('announcementModal.greenText')}>A</button>
            <button type="button" className="color-btn text-color-btn" style={{ color: '#0f172a' }} onClick={() => formatText('foreColor', '#0f172a')} title={t('announcementModal.defaultText')}>A</button>

            <div className="toolbar-divider"></div>

            <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: '4px' }}>{t('announcementModal.highlightLabel')} 🖋️</span>
            <button type="button" className="color-btn" style={{ background: 'yellow' }} onClick={() => formatText('backColor', 'yellow')} title={t('announcementModal.yellowHighlight')}></button>
            <button type="button" className="color-btn" style={{ background: '#a7f3d0' }} onClick={() => formatText('backColor', '#a7f3d0')} title={t('announcementModal.greenHighlight')}></button>
            <button type="button" className="color-btn" style={{ background: '#fbcfe8' }} onClick={() => formatText('backColor', '#fbcfe8')} title={t('announcementModal.pinkHighlight')}></button>
            <button type="button" className="color-btn" style={{ background: 'white', fontSize: '0.75rem' }} onClick={() => formatText('backColor', 'transparent')} title={t('announcementModal.clearHighlight')}>✕</button>
        </div>
        <div id="announcementMessage" contenteditable="true" className="login-input-announcement rich-editor" placeholder={t('announcementModal.messagePlaceholder')}></div>

        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px', fontSize: '0.9rem', fontWeight: '600', color: 'var(--text-main)', cursor: 'pointer' }}>
            <input type="checkbox" id="announcementImportant" style={{ width: '18px', height: '18px', accentColor: 'var(--del-color)' }} />
            {t('announcementModal.markImportant')}
        </label>

        <div style={{ display: 'flex', gap: '10px', marginTop: '4px' }}>
            <button className="btn-primary" onClick={confirmSendAnnouncement} disabled={isSubmitting}>{t('announcementModal.send')}</button>
            <button className="btn-cancel" onClick={() => closeModal()}>{t('common.cancel')}</button>
        </div>
        </div>
    </div>
    </>

    );
}

export default AnnouncementModal;